import React, { Component } from 'react';
class HardDrivesSummary extends Component {
	constructor() {
		super();
		this.state = {
			// totclk: false,
			officeclk: false,
			outstationtclk: false,
			userclk: false,
			clientclk: false,
			workingclk: false,
			backupclk: false,
			secureclk: false,
		};
	}
	componentDidMount = () => {
		this.setState({
			officeclk: this.props.officeclk2,
			outstationtclk: this.props.outstationtclk2,
			userclk: this.props.userclk2,
			clientclk: this.props.clientclk2,
			workingclk: this.props.workingclk2,
			backupclk: this.props.backupclk2,
			secureclk: this.props.secureclk2,
		});
	};
	componentWillReceiveProps = (nextProps) => {
		this.setState({
			officeclk: nextProps.officeclk2,
			outstationtclk: nextProps.outstationtclk2,
			userclk: nextProps.userclk2,
			clientclk: nextProps.clientclk2,
			workingclk: nextProps.workingclk2,
			backupclk: nextProps.backupclk2,
			secureclk: nextProps.secureclk2,
		});
	};

	getCategorycount = (type) => {
		if (this.props.data.length !== 0) {
			for (let i = 0; i < this.props.data.categoryFilters.length; i++) {
				if (this.props.data.categoryFilters[i].category === type) {
					return this.props.data.categoryFilters[i].count;
				}
			}
		}
		return '';
	};
	getLocationFilters = (type) => {
		if (this.props.data.length !== 0) {
			for (let i = 0; i < this.props.data.locationFilters.length; i++) {
				if (this.props.data.locationFilters[i].location === type) {
					return this.props.data.locationFilters[i].count;
				}
			}
		}
	};
	render() {
		return (
			<div
				className="mainbod"
				style={{
					width: '25vw',
					display: 'flex',
					flexDirection: 'column',
					gap: '30px',
				}}
			>
				<table
					className="hardDriveSummaryTable"
					style={{
						color: 'white',
						// border: '2px solid white',
						borderLeft: '1px solid  #383838',
						borderTop: '1px solid  #383838',
						borderCollapse: 'collapse',
						textTransform: 'uppercase',
					}}
				>
					<tr
						onClick={(e) => {
							this.setState({
								userclk: false,
								clientclk: false,
								officeclk: false,
								outstationtclk: false,
							});
							this.props.handleActiveFilter(e, 'locations', '');
						}}
					>
						<th>Total HD</th>
						<td>{this.props.data.all}</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								officeclk: !this.state.officeclk,
							});
							if (this.state.userclk === true) {
								this.setState({
									userclk: false,
								});
							}
							if (this.state.clientclk === true) {
								this.setState({
									clientclk: false,
								});
							}
							if (this.state.outstationtclk === true) {
								this.setState({
									outstationtclk: false,
								});
							}

							this.props.handleActiveFilter(e, 'locations', 'inOffice');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.officeclk ? '#2D2A50' : '',
							}}
						>
							Office
						</th>
						<td
							style={{
								backgroundColor: this.state.officeclk ? '#2D2A50' : '',
							}}
						>
							{this.getLocationFilters('inOffice')}
						</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								outstationclk: !this.state.outstationtclk,
							});
							if (this.state.officeclk === true) {
								this.setState({
									officeclk: false,
								});
							}
							if (this.state.clientclk === true) {
								this.setState({
									clientclk: false,
								});
							}
							if (this.state.userclk === true) {
								this.setState({
									userclk: false,
								});
							}
							this.props.handleActiveFilter(e, 'locations', 'outStation');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.outstationtclk ? '#2D2A50' : '',
							}}
						>
							Outstation
						</th>
						<td
							style={{
								backgroundColor: this.state.outstationtclk ? '#2D2A50' : '',
							}}
						>
							{this.getLocationFilters('outStation')}
						</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								userclk: !this.state.userclk,
							});
							if (this.state.officeclk === true) {
								this.setState({
									officeclk: false,
								});
							}
							if (this.state.clientclk === true) {
								this.setState({
									clientclk: false,
								});
							}
							if (this.state.outstationtclk === true) {
								this.setState({
									outstationtclk: false,
								});
							}
							this.props.handleActiveFilter(e, 'locations', 'employee');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.userclk ? '#2D2A50' : '',
							}}
						>
							User
						</th>
						<td
							style={{
								backgroundColor: this.state.userclk ? '#2D2A50' : '',
							}}
						>
							{this.getLocationFilters('employee')}
						</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								clientclk: !this.state.clientclk,
							});
							if (this.state.officeclk === true) {
								this.setState({
									officeclk: false,
								});
							}
							if (this.state.userclk === true) {
								this.setState({
									userclk: false,
								});
							}
							if (this.state.outstationtclk === true) {
								this.setState({
									outstationtclk: false,
								});
							}
							this.props.handleActiveFilter(e, 'locations', 'client');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.clientclk ? '#2D2A50' : '',
							}}
						>
							Client
						</th>
						<td
							style={{
								backgroundColor: this.state.clientclk ? '#2D2A50' : '',
							}}
						>
							{this.getLocationFilters('client')}
						</td>
					</tr>
				</table>
				<table
					className="hardDriveSummaryTable"
					style={{
						color: 'white',
						// border: '2px solid white',
						borderLeft: '1px solid  #383838',
						borderTop: '1px solid  #383838',
						borderCollapse: 'collapse',
						textTransform: 'uppercase',
					}}
				>
					<tr
						onClick={(e) => {
							if (this.state.backupclk === true) {
								this.setState({
									backupclk: false,
								});
							}
							if (this.state.secureclk === true) {
								this.setState({
									secureclk: false,
								});
							}
							if (this.state.workingclk === true) {
								this.setState({
									workingclk: false,
								});
							}

							this.props.handleActiveFilter(e, 'category', '');
						}}
					>
						<th>Total HD</th>
						<td>{this.props.data.all}</td>
					</tr>
					<tr
						onClick={(e) => {
							{
								this.setState({
									workingclk: !this.state.workingclk,
								});
								if (this.state.backupclk === true) {
									this.setState({
										backupclk: false,
									});
								}
								if (this.state.secureclk === true) {
									this.setState({
										secureclk: false,
									});
								}
								this.props.handleActiveFilter(e, 'category', 'working');
							}
						}}
					>
						<th
							style={{
								backgroundColor: this.state.workingclk ? '#2D2A50' : '',
							}}
						>
							Working
						</th>
						<td
							style={{
								backgroundColor: this.state.workingclk ? '#2D2A50' : '',
								color: '#03A0FF',
							}}
						>
							{this.getCategorycount('working')}
						</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								backupclk: !this.state.backupclk,
							});
							// this.props.backupclk2 = !this.props.backupclk2
							if (this.state.workingclk === true) {
								this.setState({
									workingclk: false,
								});
							}
							if (this.state.secureclk === true) {
								this.setState({
									secureclk: false,
								});
							}
							this.props.handleActiveFilter(e, 'category', 'backup');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.backupclk ? '#2D2A50' : '',
							}}
						>
							Backup
						</th>

						<td
							style={{
								backgroundColor: this.state.backupclk ? '#2D2A50' : '',
								color: '#FE2C2B',
							}}
						>
							{this.getCategorycount('backup')}
						</td>
					</tr>
					<tr
						onClick={(e) => {
							this.setState({
								secureclk: !this.state.secureclk,
							});
							if (this.state.workingclk === true) {
								this.setState({
									workingclk: false,
								});
							}
							if (this.state.backupclk === true) {
								this.setState({
									backupclk: false,
								});
							}
							this.props.handleActiveFilter(e, 'category', 'secured');
						}}
					>
						<th
							style={{
								backgroundColor: this.state.secureclk ? '#2D2A50' : '',
							}}
						>
							Secure
						</th>
						<td
							style={{
								backgroundColor: this.state.secureclk ? '#2D2A50' : '',
								color: '#7B7B7B',
							}}
						>
							{this.getCategorycount('secured')}
						</td>
					</tr>
				</table>
			</div>
		);
	}
}
export default HardDrivesSummary;
